customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        (super(), (this.originalButtonText = ""), (this.persistentTextActive = !1), (this._cart = null));
      }

      connectedCallback() {
        // Krytyczne (podpiecie submit) - synchronicznie.
        // Kosmetyka (teksty przycisku, observery) - odroczona.
        (this.initCritical(), setTimeout(() => this.initDeferred(), 100));
      }

      // Musi byc gotowe zanim uzytkownik zdazy kliknac,
      // inaczej formularz leci natywnym POST na /cart/add i Shopify robi redirect.
      initCritical() {
        if (((this.form = this.querySelector("form")), !this.form)) {
          // element wstawiony zanim dzieci zostaly sparsowane (quick-add, section render)
          ((this._initRetries = (this._initRetries || 0) + 1),
            this._initRetries < 60 && requestAnimationFrame(() => this.initCritical()));
          return;
        }

        if (this._submitBound) return;
        this._submitBound = !0;

        const t = this.variantIdInput;
        (t && (t.disabled = !1),
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
          (this.submitButton = this.querySelector('[type="submit"]')),
          (this.hideErrors = "true" === this.dataset.hideErrors),
          this.submitButton &&
            document.querySelector("cart-drawer") &&
            this.submitButton.setAttribute("aria-haspopup", "dialog"));
      }

      initDeferred() {
        if (!this.form || !this.submitButton) return;

        this.submitButtonText = this.submitButton.querySelector(".button-text");

        this.submitButtonText &&
          ((this.originalButtonText = this.submitButtonText.textContent),
          (this.submitButton.dataset.originalText = this.originalButtonText));

        const isOverride = "true" === this.submitButton.dataset.textOverride;
        const isPersistent = this.submitButton.classList.contains("has-persistent-text");

        if ((isOverride || isPersistent) && this.submitButtonText) {
          this.persistentTextActive = !0;
          const showPrice = "true" === this.submitButton.dataset.showPrice;
          const t = this.submitButton.dataset.persistentText;
          if (t) {
            if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
              this.submitButtonText.textContent = t;
            }
            localStorage.setItem("addToCartButtonText", t);
          } else {
            const stored = localStorage.getItem("addToCartButtonText");
            if (stored) {
              if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(stored.trim())) {
                this.submitButtonText.textContent = stored;
              }
              this.submitButton.dataset.persistentText = stored;
            }
          }
        }

        ((this.persistentTextActive || isOverride) && this.submitButtonText && this.setupButtonTextObserver(),
          (this._onVariantChange = this.handleVariantChange.bind(this)),
          document.addEventListener("variant:change", this._onVariantChange));
      }

      setupButtonTextObserver() {
        if (!this.submitButtonText) return;
        const t = { characterData: !0, childList: !0, subtree: !0 };
        if (this.persistentTextActive) {
          const e = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
          if (!e) return;
          const showPrice = "true" === this.submitButton.dataset.showPrice;
          ((this.buttonTextObserver = new MutationObserver((t) => {
            const currentText = this.submitButtonText.textContent.trim();
            const persistentText = e.trim();
            if (showPrice) {
              if (!currentText.startsWith(persistentText)) {
                this.submitButtonText.textContent = e;
              }
            } else {
              if (currentText !== persistentText) {
                this.submitButtonText.textContent = e;
              }
            }
          })),
            this.buttonTextObserver.observe(this.submitButtonText, t));
        }
      }

      handleVariantChange(t) {
        this.submitButtonText &&
          setTimeout(() => {
            if (this.persistentTextActive) {
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              if (!showPrice) {
                const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
                t && (this.submitButtonText.textContent = t);
              }
            }
          }, 50);
      }

      ensureSellingPlanValue() {
        let planIdToUse = null;
        try {
          const sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
          if (sellingPlanInput) {
            if (sellingPlanInput.value) {
              planIdToUse = sellingPlanInput.value;
            } else {
              const subscribeToggle = document.querySelector('.subscribe-save-wrapper input[type="checkbox"]:checked, .subscribe-save-wrapper-dynamic input[type="checkbox"]:checked');
              if (subscribeToggle) {
                const wrapper = subscribeToggle.closest('.subscribe-save-wrapper, .subscribe-save-wrapper-dynamic');
                if (wrapper) {
                  planIdToUse = wrapper.dataset.sellingPlanId || subscribeToggle.dataset.planId;
                }

                if (planIdToUse) {
                  sellingPlanInput.value = planIdToUse;
                  sellingPlanInput.setAttribute('value', planIdToUse);
                }
              }
            }
          }
        } catch (error) {
          console.warn('⚠️ product-form.js: Error setting selling_plan:', error);
        }
        return planIdToUse;
      }

      onSubmitHandler(t) {
        if ((t.preventDefault(), !this.submitButton)) return;
        if ("true" === this.submitButton.getAttribute("aria-disabled")) return;

        (this.handleErrorMessage(),
          this.submitButton.setAttribute("aria-disabled", !0),
          this.submitButton.classList.add("loading"));

        const spinner = this.querySelector(".loading__spinner");
        spinner && spinner.classList.remove("hidden");

        const e = fetchConfig("javascript");
        ((e.headers["X-Requested-With"] = "XMLHttpRequest"), delete e.headers["Content-Type"]);

        this.ensureSellingPlanValue();

        const s = new FormData(this.form);

        (this.cart &&
          (s.append(
            "sections",
            this.cart.getSectionsToRender().map((t) => t.id),
          ),
          s.append("sections_url", window.location.pathname),
          this.cart.setActiveElement(document.activeElement)),
          (e.body = s),
          fetch(`${routes.cart_add_url}`, e)
            .then((t) => t.json())
            .then(this.handleCartResponse.bind(this, s, t))
            .catch((t) => {
              console.error(t);
            })
            .finally(this.handleSubmitFinally.bind(this, t)));
      }

      handleCartResponse(formData, event, responseData) {
        if (responseData.status) {
          (publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: responseData.errors || responseData.description,
            message: responseData.message,
          }),
            this.handleErrorMessage(responseData.description));
          const e = this.submitButton.querySelector(".sold-out-message");
          if (!e) return;
          return (
            this.submitButton.setAttribute("aria-disabled", !0),
            this.submitButtonText && this.submitButtonText.classList.add("hidden"),
            e.classList.remove("hidden"),
            void (this.error = !0)
          );
        }
                // skip-to-checkout: dopiero PO potwierdzonym dodaniu do koszyka
        if ("true" === this.dataset.skipToCheckout) {
          const root = (window.routes && window.routes.root_url) || "";
          window.location = root.replace(/\/$/, "") + "/checkout";
          return;
        }
        if (!this.cart) return void (window.location = window.routes.cart_url);
        const e = CartPerformance.createStartingMarker("add:wait-for-subscribers");
        (this.error ||
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
            cartData: responseData,
          }).then(() => {
            CartPerformance.measureFromMarker("add:wait-for-subscribers", e);
          }),
          (this.error = !1));
        const i = this.closest("quick-add-modal");
        i
          ? (document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(responseData);
                  });
                });
              },
              { once: !0 },
            ),
            i.hide(!0))
          : CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(responseData);
            });
      }

      handleSubmitFinally(event) {
        this.submitButton && this.submitButton.classList.remove("loading");
        this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty");
        this.error || !this.submitButton || this.submitButton.removeAttribute("aria-disabled");

        const spinner = this.querySelector(".loading__spinner");
        spinner && spinner.classList.add("hidden");

        if (this.error || !this.submitButton || "true" !== this.submitButton.dataset.textOverride) {
          if (!this.error && this.persistentTextActive) {
            const showPrice = "true" === this.submitButton.dataset.showPrice;
            const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            if (t && this.submitButtonText) {
              if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                this.submitButtonText.textContent = t;
              }
            }
          }
        }
        CartPerformance.measureFromEvent("add:user-action", event);
      }

      handleErrorMessage(t = !1) {
        this.hideErrors ||
          ((this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")),
            this.errorMessageWrapper.toggleAttribute("hidden", !t),
            t && (this.errorMessage.textContent = t)));
      }

      toggleSubmitButton(t = !0, e) {
        if (!this.submitButton) return;
        if (t) (this.submitButton.setAttribute("disabled", "disabled"), e && this.submitButtonText && (this.submitButtonText.textContent = e));
        else {
          if ((this.submitButton.removeAttribute("disabled"), "true" === this.submitButton.dataset.textOverride));
          else if (this.persistentTextActive) {
            const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            if (t) return void (this.submitButtonText && (this.submitButtonText.textContent = t));
          }
          if (!this.submitButtonText) return;
          this.originalButtonText
            ? (this.submitButtonText.textContent = this.originalButtonText)
            : this.submitButton.dataset.originalText
              ? (this.submitButtonText.textContent = this.submitButton.dataset.originalText)
              : (this.submitButtonText.textContent = window.variantStrings.addToCart);
        }
      }

      disconnectedCallback() {
        (this.buttonTextObserver && this.buttonTextObserver.disconnect(),
          this._onVariantChange && document.removeEventListener("variant:change", this._onVariantChange));
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }

      get cart() {
        return (
          this._cart ||
          (this._cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer"))
        );
      }
    },
  );